export const VALID_SHELL_COMMAND_OPTIONS_REGEX = /^[A-Za-z0-9.,/_@%^:=+ -]*$/;
export const VALID_USERNAME_REGEX = /^[a-zA-Z0-9_][a-zA-Z0-9._-]*\$?$/;
export const VALID_PASSWORD_REGEX = /^[A-Za-z0-9.,/_@%^:=+ -]*$/;
export const VALID_IPV4_ADDRESS_REGEX =
  /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
export const VALID_HOSTNAME_REGEX =
  /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/;
export const VALID_ATTRIBUTE_KEY_NAME_REGEX =
  /^[a-zA-Z]([a-zA-Z0-9_]*[a-zA-Z0-9])?$/;
export const VALID_SLUG_REGEX = /^[a-zA-Z0-9_-]*$/;
export const VALID_MEASURE_UNIT_REGEX = /[kMGTP]$/;
export const ONLY_ARANGO_ALLOWED_CHARS_REGEX =
  /^[a-zA-Z0-9_\-:.@()+,=;$!*'%]*$/;

// Supported formats: f4:d4:88:63:65:8e, f4-d4-88-63-65-8e, f4d4.8863.658e
export const VALID_MAC_ADDRESS_REGEX =
  /^(([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})|([0-9A-Fa-f]{4}.){2}([0-9A-Fa-f]{4}))$/;

export const CLI_DEFAULT_UNAUTHENTICATED_TIMEOUT = 5 * 60; // in seconds;
export const CLI_DEFAULT_LOGIN_TIMEOUT = 20; // in seconds;
export const CLI_DEFAULT_DATA_TIMEOUT = 20; // in seconds;
export const CLI_DEFAULT_COMMAND_RESPONSE_TIMEOUT = 3 * 60 * 60; // in seconds;
export const CLI_DEFAULT_EXIT_COMMAND_TIMEOUT = 5; // in seconds;

export const MAX_SERVICE_RESTARTS_LIMIT = {
  min: 1,
  max: 1000,
};
// Maximum value for "now gt" and "now lt" filter operations
export const DATE_NOW_MAX_DAYS = 365 * 100; // 100 years in days

// TODO NIM-16381: Investigate relevance of this prefix
export const AP_DEVICE_TASK_ID_MAGIC_PREFIX = 'lap-';

// Regex tests if the string contains only a-zA-Z0-9 and is at least 2 characters long
// "-" are also allowed but on at the beginning or end of the string, they cannot be consecutive
export const CONTAINER_ID_RE = /^(?!-)(?!.*--)[a-zA-Z0-9-]{2,}(?<!-)$/;
export const CONTAINER_NAME_RE = /^(?!-)(?!.*--)[a-zA-Z0-9-]{2,}(?<!-)$/;
